export enum RiskManagementTab {
  AllSuppliers = 0,
  AssignedToYou = 1,
  AssignedToOthers = 2,
  Unassigned = 3,
}
